import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, IconGoogle } from "../../../../components/atoms";
import { InputGroup, SelectGroup } from "../../../../components/molecules";
import { AuthContext } from "../../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../../helpers";
import { useApi } from "../../../../hooks/useApi";

const theObjectsAreTheSame = (objA: Object, objB: Object) => {
  return JSON.stringify(objA) === JSON.stringify(objB);
};

export function FormPartnerEdit() {
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const { parceiroID } = useParams();
  const { getParceiro } = useApi();

  const { applicationData } = useContext(AuthContext);
  const [campoObrigatorioNome, setcampoObrigatorioNome] =
    useState<boolean>(false);
  const [campoObrigatorioTelefone, setcampoObrigatorioTelefone] =
    useState<boolean>(false);
  const [campoObrigatorioCNPJ, setcampoObrigatorioCNPJ] =
    useState<boolean>(false);
  const [campoObrigatorioCidade, setcampoObrigatorioCidade] =
    useState<boolean>(false);
  const [campoObrigatorioRazao, setcampoObrigatorioRazao] =
    useState<boolean>(false);
  const [campoObrigatorioEndereco, setcampoObrigatorioEndereco] =
    useState<boolean>(false);
  const [campoObrigatorioBairro, setcampoObrigatorioBairro] =
    useState<boolean>(false);
  const [campoObrigatorioNumero, setcampoObrigatorioNumero] =
    useState<boolean>(false);
  const [campoObrigatorioOperacao, setcampoObrigatorioOperacao] =
    useState<boolean>(false);

  const [parceiro, setParceiro] = useState<Cliente>({
    codigo: 0,
    ncidade: "",
    nome: "",
    telefone: "",
    cnpj: "0",
    cidade: 0,
    razao: "",
    endereco: "",
    bairro: "",
    numero: "",
    operacao: 0,
    email: "",
    complemento: "",
    cep: "",
    inscricaoestadual: "",
    inscricaomunicipal: "",
    banco: 0,
    agencia: "",
    conta: "",
    limite: 0,
    comissao: 0,
    gcliente: 0,
    gfornecedor: 0,
    senha: "",
    obs: "",
  });

  const gravar = async () => {
    let useredit = applicationData.funcionario;
    const response = await api.post("/api/cliente/editjson", {
      vcodigo: parceiro.codigo,
      vnome: parceiro.nome,
      vtelefone: parceiro.telefone,
      vcnpj: parceiro.cnpj,
      vcidade: parceiro.cidade,
      vrazao: parceiro.razao,
      vendereco: parceiro.endereco,
      vbairro: parceiro.bairro,
      vnumero: parceiro.numero,
      voperacao: parceiro.operacao,
      vemail: parceiro.email,
      vcomplemento: parceiro.complemento,
      vcep: parceiro.cep,
      vinscricaoestadual: parceiro.inscricaoestadual,
      vinscricaomunicipal: parceiro.inscricaomunicipal,
      vbanco: parceiro.banco,
      vagencia: parceiro.agencia,
      vconta: parceiro.conta,
      vlimite: parceiro.limite,
      vcomissao: parceiro.comissao,
      vvendedor: parceiro.gcliente,
      vfornecedor: parceiro.gfornecedor,
      vsenha: parceiro.senha,
      vobs: parceiro.obs,
      useredit,
    });
    if (response.status === 200) {
      setType("success");
      setTextAlert(response.statusText);
      setShow(true);
    }
  };

  useEffect(() => {
    (async () => {
      const parceiroInfo = await getParceiro(parceiroID!);
      if (parceiroInfo && !theObjectsAreTheSame(parceiro, parceiroInfo)) {
        setParceiro((current: any) => ({ ...current, ...parceiroInfo }));
      }
    })();
  }, []);

  return (
    <div>
      <h2>Alterar Parceiro</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Nome"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="nome"
            type="string"
            value={parceiro.nome}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNome(true);
              else {
                setParceiro({ ...parceiro, nome: e.target.value });
                setcampoObrigatorioNome(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="CNPJ"
            messageError={campoObrigatorioCNPJ ? "Campo obrigatório!" : ""}
            id="cnpj"
            type="string"
            value={String(parceiro.cnpj)}
            maxLength={14}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioCNPJ(true);
              else {
                setParceiro({ ...parceiro, cnpj: e.target.value });
                setcampoObrigatorioCNPJ(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Telefone"
            messageError={campoObrigatorioTelefone ? "Campo obrigatório!" : ""}
            id="telefone"
            type="string"
            value={String(parceiro.telefone)}
            maxLength={14}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioTelefone(true);
              else {
                setParceiro({ ...parceiro, telefone: e.target.value });
                setcampoObrigatorioTelefone(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Razao"
            messageError={campoObrigatorioRazao ? "Campo obrigatório!" : ""}
            id="razao"
            type="string"
            value={parceiro.razao}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioRazao(true);
              else {
                setParceiro({ ...parceiro, razao: e.target.value });
                setcampoObrigatorioRazao(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Email"
            id="email"
            type="string"
            value={String(parceiro.email)}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, email: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="% Comissao"
            id="comissao"
            type="number"
            value={String(parceiro.comissao)}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 100 &&
                Number(e.target.value) >= 0
              ) {
                setParceiro({ ...parceiro, comissao: Number(e.target.value) });
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Endereco"
            messageError={campoObrigatorioEndereco ? "Campo obrigatório!" : ""}
            id="endereco"
            type="string"
            value={parceiro.endereco}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioEndereco(true);
              else {
                setParceiro({ ...parceiro, endereco: e.target.value });
                setcampoObrigatorioEndereco(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Complemento"
            id="complemento"
            type="string"
            value={String(parceiro.complemento)}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, complemento: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Numero"
            messageError={campoObrigatorioNumero ? "Campo obrigatório!" : ""}
            id="numero"
            type="string"
            value={parceiro.numero}
            maxLength={10}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioNumero(true);
              else {
                setParceiro({ ...parceiro, numero: e.target.value });
                setcampoObrigatorioNumero(false);
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Bairro"
            messageError={campoObrigatorioBairro ? "Campo obrigatório!" : ""}
            id="bairro"
            type="string"
            value={parceiro.bairro}
            maxLength={50}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setcampoObrigatorioBairro(true);
              else {
                setParceiro({ ...parceiro, bairro: e.target.value });
                setcampoObrigatorioBairro(false);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Cep"
            id="cep"
            type="string"
            value={String(parceiro.cep)}
            minLength={8}
            maxLength={8}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, cep: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(parceiro.cidade)}
            id="cidade"
            messageError={campoObrigatorioCidade ? "Campo obrigatório!" : ""}
            label="Cidade"
            options={applicationData.cidades.map((cidade: Cidade) => ({
              text: cidade.nome,
              value: cidade.codigo,
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) > 0
              ) {
                setParceiro({ ...parceiro, cidade: Number(e.target.value) });
                setcampoObrigatorioCidade(false);
              }
              if (e.target.value === "") setcampoObrigatorioCidade(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(parceiro.operacao)}
            id="operacao"
            messageError={campoObrigatorioOperacao ? "Campo obrigatório!" : ""}
            label="Operacao"
            options={applicationData.operacoes.map((operacao: Operacao) => ({
              text: operacao.nome,
              value: operacao.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                setParceiro({ ...parceiro, operacao: Number(e.target.value) });
                setcampoObrigatorioOperacao(false);
              }
              if (e.target.value === "") setcampoObrigatorioOperacao(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Inscricao Estadual"
            id="inscestadual"
            type="string"
            value={String(parceiro.inscricaoestadual)}
            maxLength={15}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, inscricaoestadual: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(parceiro.gcliente)}
            id="vendedor"
            label="Vendedor"
            options={applicationData.gparceiros.map((gparceiro: GParceiro) => ({
              text: gparceiro.nome,
              value: gparceiro.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                setParceiro({ ...parceiro, gcliente: Number(e.target.value) });
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(parceiro.gfornecedor)}
            id="fornecedor"
            label="Fornecedor"
            options={applicationData.gparceiros.map((gparceiro: GParceiro) => ({
              text: gparceiro.nome,
              value: gparceiro.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                setParceiro({
                  ...parceiro,
                  gfornecedor: Number(e.target.value),
                });
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Limite (R$)"
            id="limite"
            type="number"
            value={String(parceiro.limite)}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) > 0
              ) {
                setParceiro({ ...parceiro, limite: Number(e.target.value) });
              }
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Inscricao Municipal"
            id="inscmunicipal"
            type="string"
            value={String(parceiro.inscricaomunicipal)}
            maxLength={10}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({
                  ...parceiro,
                  inscricaomunicipal: e.target.value,
                });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(parceiro.banco)}
            id="banco"
            label="Banco"
            options={applicationData.bancos.map((banco: Banco) => ({
              text: banco.banco,
              value: banco.codigo,
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) >= 0
              ) {
                setParceiro({ ...parceiro, banco: Number(e.target.value) });
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Agencia Bancaria"
            id="agencia"
            type="string"
            value={String(parceiro.agencia)}
            maxLength={15}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, agencia: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Conta Corrente"
            id="conta"
            type="string"
            value={String(parceiro.conta)}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, conta: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Senha"
            id="senha"
            type="string"
            value={String(parceiro.senha)}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, senha: e.target.value });
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-9">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Observacao"
            messageError={campoObrigatorioNome ? "Campo obrigatório!" : ""}
            id="obs"
            type="string"
            value={String(parceiro.obs)}
            maxLength={250}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value !== "")
                setParceiro({ ...parceiro, obs: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar();
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  );
}
